import EFPic from '@/components/UI/EFPic';
import EFMouseArrow from '@/components/UI/svg/CSR/Icons/EFMouseArrow';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';

export default function G() {
    const { useLang, useEffect } = useGlobal();
    const { t } = useLang('csr');

    let controller: any;
    useEffect(()=>{
        controller = new ScrollMagic.Controller()
    }, [])

    useEffect(()=>{
        new ScrollMagic.Scene({
            triggerElement: '.csr_h5_G',
            triggerHook: 1,
            offset: 400,
        })
            .setClassToggle('.csr_h5_G', 'enter')
            .addTo(controller)
    }, [])

    return (
        <div className={`csr_h5_G ${css.csr_h5_G}`}>
            <div className="innerBox">
                <div className="imgBox">
                    <div className="img">
                        <EFPic src={['/img/csr/h5/7.webp', '/img/csr/h5/7.jpg']} alt={t('secG_title')} aria-label={t('secG_title')} />
                    </div>
                </div>
                <div className="textBox">
                    <div className="titleBox">
                        <p className="title">{t('secG_title')}</p>
                    </div>
                    <div className="descBox">
                        <p className="desc">{t('secG_desc')}</p>
                    </div>
                </div>
                <div className="lineBox">
                    <div className="line">
                    </div>
                    <div className="icon">
                        <EFMouseArrow width="0.3rem" height="0.3rem" />
                    </div>
                </div>
                <div className="mailBox">
                    <a href={`mailto:${t('secG_mail')}`} className="mail">{t('secG_mail')}</a>
                </div>
            </div>
        </div>
    );
}
